import {BarcodeStatus, BarcodeType, IBarcode} from '../domain/accounts/IBarcode';
import {Retailer} from '../domain/accounts/retailer';

export class BarcodeEntity implements IBarcode{
  id: string;
  expirationDate: Date | null;
  lastChangedDate: Date | null;
  creationDate: Date | null;
  type: string;
  status: BarcodeStatus;
  retailer: Retailer;
  amount: number;
  targetFirstName: string | null;
  targetLastName: string | null;
  targetReference: string | null;
  loadType: BarcodeType;
  retailerKey: number | null;

  constructor() {
    this.retailer = new Retailer();
    this.status = BarcodeStatus.NEW;
    this.loadType = BarcodeType.OWNER_ACCOUNT;
  }
}
